module.exports = __webpack_public_path__ + "img/arrow-right.bcf7a0d4.svg";